<kendo-dialog-titlebar>
	<span *ngIf="!editMode">{{ 'documents.sharedClaimLinks.addNew' | translate }}</span>
	<span *ngIf="editMode">{{ 'documents.sharedClaimLinks.preview' | translate }}</span>
</kendo-dialog-titlebar>

<form *ngIf="sharedClaimDocumentLinkForm" [formGroup]="sharedClaimDocumentLinkForm">
	<app-shared-claim-document-link-form [form]="sharedClaimDocumentLinkForm"
		[readonlyFields]="editMode" [editMode]="editMode"
		[sharedDocumentLink]="sharedDocumentLink" [pinCode]="sharedClaimDocumentLink.pinCode">
	</app-shared-claim-document-link-form>
</form>

<kendo-dialog-actions>
	<button kendoButton type="button" (click)="cancel()">{{ 'global.cancel' | translate }}</button>
	<button *ngIf="!editMode" kendoButton type="button" [primary]="true" (click)="confirm()">
		{{ 'global.add' | translate }}
	</button>
</kendo-dialog-actions>
